export default "__VITE_ASSET__Inppzosh__"